<template>
  <div id="app" :style="{ direction: $store.state.isMirroring ? 'rtl' : 'ltr' }">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :style="{ paddingTop: $store.state.statusBarHeight + 'px' }" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :style="{ paddingTop: $store.state.statusBarHeight + 'px' }" />
  </div>
</template>

<script>
import { reportWalletOpenOnce } from '@/utils/log'

export default {
  name: 'App',
  created() {
    this.getIsMirroring()
    reportWalletOpenOnce({
      path: this.$route.path,
      apptype: this.$route.query.apptype || (typeof localStorage !== 'undefined' && localStorage.getItem('apptype')) || ''
    })
  },
  mounted() {
    this.lockPortraitMode()
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationChange)
  },
  methods: {
    getIsMirroring() {
      const isMirror = localStorage.getItem('isMirror')
      this.$store.commit('setIsMirroring', !!(isMirror && isMirror === '1'))
    },
    lockPortraitMode() {
      // 监听屏幕方向变化
      document.addEventListener('orientationchange', this.handleOrientationChange)
      // 立即检查并锁定竖屏
      this.handleOrientationChange()
    },
    handleOrientationChange() {
      if (screen.orientation.type !== 'portrait-primary' && screen.orientation.type !== 'portrait-secondary') {
        // 尝试锁定为竖屏
        screen.orientation.lock('portrait-primary').catch((error) => {
          console.warn('屏幕方向锁定失败:', error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue